module.exports = __webpack_public_path__ + "images/new-products/ELCONEXT-2d6b43127c82e2b9a73120e225af279e.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/new-products/ELCONEXT.jpg
 ** module id = 289
 ** module chunks = 0
 **/